import React from 'react';
import { useApp } from '../context/AppContext';
import CurriculumChat from '../components/CurriculumChat';

function About() {
  const { t } = useApp();

  return (
    <div className="min-h-screen pt-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold title-gradient mb-8">
          {t('about.title')}
        </h1>
        
        <section className="mb-12 glass-effect p-6 rounded-lg">
          <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-4">
            {t('about.profile.title')}
          </h2>
          <p className="card-text">
            {t('about.profile.description')}
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-6">
            {t('about.skills.title')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="glass-effect p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">
                {t('about.skills.programming.title')}
              </h3>
              <ul className="space-y-2">
                {t('about.skills.programming.items').map((item, index) => (
                  <li key={index} className="flex items-center card-text">
                    <span className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full mr-2"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="glass-effect p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">
                {t('about.skills.tools.title')}
              </h3>
              <ul className="space-y-2">
                {t('about.skills.tools.items').map((item, index) => (
                  <li key={index} className="flex items-center card-text">
                    <span className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full mr-2"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="glass-effect p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">
                {t('about.skills.visualization.title')}
              </h3>
              <ul className="space-y-2">
                {t('about.skills.visualization.items').map((item, index) => (
                  <li key={index} className="flex items-center card-text">
                    <span className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full mr-2"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="glass-effect p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">
                {t('about.skills.cloud.title')}
              </h3>
              <ul className="space-y-2">
                {t('about.skills.cloud.items').map((item, index) => (
                  <li key={index} className="flex items-center card-text">
                    <span className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full mr-2"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-6">
            {t('about.experience.title')}
          </h2>
          <div className="space-y-6">
            {t('about.experience.jobs').map((job, index) => (
              <div key={index} className="glass-effect p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-text-light dark:text-text-dark">
                  {job.title}
                </h3>
                <p className="text-primary-light dark:text-primary-dark mb-2">
                  {job.company}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                  {job.period}
                </p>
                <ul className="space-y-2">
                  {job.responsibilities.map((item, idx) => (
                    <li key={idx} className="flex items-start card-text">
                      <span className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full mr-2 mt-2"></span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-6">
            {t('about.experience.education.title')}
          </h2>
          <div className="space-y-6">
            {t('about.experience.education.items').map((edu, index) => (
              <div key={index} className="glass-effect p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-text-light dark:text-text-dark">
                  {edu.degree}
                </h3>
                <p className="text-primary-light dark:text-primary-dark mb-2">
                  {edu.institution}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                  {edu.period}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {edu.location}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <CurriculumChat />
        </section>
      </div>
    </div>
  );
}

export default About; 